import React, { useEffect } from "react";
import FormInputText from "../../Component/FormInputText";
import {
  FormInputDropdown,
  generateSingleOptions,
} from "../../Component/FormComponent/FormInputDropdown";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Container } from "@mui/system";

import {
  optionsUserCategory,
  optionsUserType,
} from "../../select-options/options";
import { green } from "@mui/material/colors";
import styled from "@emotion/styled";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Fade } from "react-awesome-reveal";
import { useLoginUserMutation } from "../../services/apiSlice";

const defaultValues = {
  password: "",
  email: "",
};
//
const Login = () => {
  const methods = useForm({ defaultValues: defaultValues });
  const {
    handleSubmit,

    register,

    formState: { errors },
  } = methods;

  const navigate = useNavigate();
  const location = useLocation();

  const [loginUser, { data, error, isError, isSuccess }] =
    useLoginUserMutation();
  let from =
    location.state?.from?.pathname + location.state?.from?.search ||
    "/dashboard";
  let search = location.state?.from?.search;

  console.log({ from, location });
  useEffect(() => {
    console.log({ data });
    if (isSuccess && data && data?.success === true) {
      Swal.fire("Awesome!", ` ${data.message}`, "success").then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          navigate(from);
        }
      });
    } else if (isError) {
      //error
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
    } else if (data?.success === false) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data?.message,
      });
    }
  }, [data, isError]);

  const onSubmit = async (data) => {
    console.log("register", data);
    await loginUser(data);
  };

  return (
    <>
      <Fade cascade>
        <Container>
          <Box maxWidth={"md"} className="min-h-screen" sx={{ mt: 10, py: 5 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Paper
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gridRowGap: "20px",
                  padding: "20px",
                  // margin: "30px 300px",
                }}
                sx={[
                  {
                    width: "md",
                  },
                  (theme) => ({
                    [theme.breakpoints.down("sm")]: {
                      px: 1,
                      width: "sm",
                      // height: "25%",
                    },
                  }),
                ]}
              >
                <Typography
                  variant="h1"
                  component="h2"
                  className="text-3xl uppercase font-extrabold text-center py-2 md:py-4 "
                  sx={{ textAlign: "center" }}
                >
                  Sign In
                </Typography>
                <TextField
                  label="E-mail"
                  variant="outlined"
                  fullWidth
                  name="email"
                  size={"small"}
                  {...register("email", {
                    required: "Email is Required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address",
                    },
                  })}
                  error={Boolean(errors.email)}
                  helperText={
                    errors.email && errors.email.type === "required"
                      ? errors.email.message
                      : errors.email &&
                        errors.email.type === "pattern" &&
                        errors.email.message
                  }
                />
                <TextField
                  name="password"
                  label="Password"
                  variant="outlined"
                  fullWidth
                  size={"small"}
                  type={"password"}
                  {...register("password", {
                    required: "password  is Required",
                    minLength: {
                      value: 8,
                      message: "Password should have at-least 8 characters.",
                    },
                    pattern: {
                      value:
                        /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message:
                        "The password must contain atleast one uppercase, one lowercase and one special characters",
                    },
                  })}
                  error={Boolean(errors.password)}
                  helperText={
                    errors.password && errors.password.type === "required"
                      ? errors.password.message
                      : errors.password && errors.password.type === "minLength"
                      ? errors.password.message
                      : errors.password &&
                        errors.password.type === "pattern" &&
                        errors.password.message
                  }
                />
                <div className="clearfix"></div>
                <Button
                  variant="contained"
                  type="submit"
                  className="hover:bg-green-300"
                  sx={{
                    color: "white",
                    background: green[600],
                    // width: "40%",
                    // mx: 30,
                    textAlign: "center",
                    placeItems: "center",
                  }}
                >
                  Sign In
                </Button>
                <Typography
                  variant="p"
                  component="p"
                  className="text-base  font-normal text-center py-2  "
                  sx={{ textAlign: "center" }}
                >
                  Don't remebered your password?{" "}
                  <Link to={"/forget-password-request"}>
                    {" "}
                    <Typography
                      variant="span"
                      component="span"
                      className="text-blue-500 text-lg  mx-2 font-normal text-center   "
                      sx={{ textAlign: "center" }}
                    >
                      Forget password
                    </Typography>{" "}
                  </Link>
                </Typography>{" "}
                <Typography
                  variant="p"
                  component="p"
                  className="text-base  font-normal text-center   "
                  sx={{ textAlign: "center" }}
                >
                  Don't have an account?{" "}
                  <Link to={"/register"}>
                    {" "}
                    <Typography
                      variant="span"
                      component="span"
                      className="text-blue-500 text-lg  mx-2 font-normal text-center py-2  "
                      sx={{ textAlign: "center" }}
                    >
                      Register
                    </Typography>{" "}
                  </Link>
                </Typography>
              </Paper>
            </form>
          </Box>
        </Container>
      </Fade>
    </>
  );
};

export default Login;
